/**
 * Animalume - 16타입 메타데이터（韓国語）
 *
 * 注: ネイティブレビュー前のClaudeドラフト
 * 韓国市場で一般的に使われる呼称を採用（16personalities系の事実上の標準語彙）
 */


import type { MbtiType } from '@/features/diagnosis/logic/types';
import type { TypeMeta } from './meta-ja';

export const TYPE_META_KO: Record<MbtiType, TypeMeta> = {
  INTJ: {
    code: 'INTJ',
    nameJa: '건축가',
    groupJa: '빛의 탐구자들',
    groupCode: 'NT',
    tagline: '미래의 지도를, 홀로 조용히 그려가는 사람',
    essence: '본질을 꿰뚫어보고, 장기적인 계획으로 세상을 구조화하는 사람',
    folderName: '01intj',
    strengths: [
      '본질을 꿰뚫어보고, 복잡한 상황 속에서 구조를 발견하는 힘',
      '장기적인 시각으로 계획을 세우고, 묵묵히 실행하는 능력',
      '타인의 평가에 흔들리지 않고, 자신만의 판단 기준을 가진 독립성',
    ],
    relationshipNote: '인간관계는 넓지 않지만 깊다는 것이 INTJ의 특징일 수 있습니다. 한번 신뢰한 상대에게는 겉으로 드러내지 않는 섬세함과 내면의 열정을 나눌 수 있는 사람. 다만, 상대에게도 같은 깊이를 요구하는 경향이 있어, 표면적인 대화만 나누는 관계에는 쉽게 지치는 면도 있을 것입니다.',
  },
  INTP: {
    code: 'INTP',
    nameJa: '논리술사',
    groupJa: '빛의 탐구자들',
    groupCode: 'NT',
    tagline: '사고의 미로에 사는, 지적 호기심의 탐구자',
    essence: '원리와 구조에 끌리며, 순수한 이해를 추구하는 사람',
    folderName: '02intp',
    strengths: [
      '복잡한 문제를 논리적으로 분해하고, 근본적인 모순을 발견하는 힘',
      '기존 전제를 의심하고, 새로운 시각에서 사물을 재구성하는 능력',
      '지식을 체계화하고, 넓은 분야를 가로질러 학습하는 지적 호기심',
    ],
    relationshipNote: '깊은 지적 대화가 가능한 상대를 자연스럽게 끌어당기는 경향이 있습니다. 감정 표현이 적어 보일 수 있지만, 내면에는 풍부한 사고의 세계가 있으며, 진정으로 신뢰한 사람에게는 그것을 열어가는 면이 있습니다.',
  },
  ENTJ: {
    code: 'ENTJ',
    nameJa: '통솔자',
    groupJa: '빛의 탐구자들',
    groupCode: 'NT',
    tagline: '길을 개척하고, 비전을 실현하는 사람',
    essence: '결단력과 리더십으로, 스스로 미래를 만들어가는 사람',
    folderName: '03entj',
    strengths: [
      '방향을 제시하고, 주변을 목표를 향해 움직이는 리더십',
      '문제의 본질을 빠르게 파악하고, 결단하여 실행에 옮기는 행동력',
      '장기적 비전을 그리면서, 단기 과제도 동시에 관리하는 전략적 사고',
    ],
    relationshipNote: '상대에 대한 기대 수준이 높아지는 경향이 있어, 때로는 그것이 압박으로 느껴질 수 있습니다. 하지만 그 근저에는 상대에 대한 깊은 신뢰와 기대가 있습니다. 대등하게 토론할 수 있는 상대와의 관계에서 특별한 충실감을 느끼는 면이 있습니다.',
  },
  ENTP: {
    code: 'ENTP',
    nameJa: '변론가',
    groupJa: '빛의 탐구자들',
    groupCode: 'NT',
    tagline: '영감을 연결하고, 새로운 시각으로 세상을 비추는 사람',
    essence: '가능성을 발견하고, 기존의 틀을 흔드는 사람',
    folderName: '04entp',
    strengths: [
      '사물의 다면성을 순식간에 파악하고, 독창적인 아이디어를 생성하는 발상력',
      '토론 속에서 사고를 심화시키고, 새로운 관점을 발견하는 지적 민첩성',
      '변화를 두려워하지 않고, 미지의 상황에도 유연하게 적응하는 능력',
    ],
    relationshipNote: '지적인 자극이 있는 관계에서 활력을 얻는 경향이 있습니다. 때로는 토론 좋아하는 성향이 지나쳐 상대를 지치게 할 수도 있지만, 그것은 본질적인 성실함과 호기심의 표현입니다. 감정의 언어를 의식적으로 사용함으로써 관계가 더욱 풍요로워질 수 있습니다.',
  },
  INFJ: {
    code: 'INFJ',
    nameJa: '옹호자',
    groupJa: '빛을 엮는 사람들',
    groupCode: 'NF',
    tagline: '달의 수호자, 사람의 영혼을 바라보는 조용한 통찰자',
    essence: '내면의 우주에서 사람의 본질을 바라보고, 깊이 이해하는 사람',
    folderName: '05infj',
    strengths: [
      '언어화되지 않은 감정과 동기를 느껴내는 깊은 직관적 통찰력',
      '장기적인 시각으로 비전을 그리고, 사람을 끌어들이며 실현하는 힘',
      '이상에 대한 강한 신념을 가지면서, 현실과의 다리를 놓는 실천력',
    ],
    relationshipNote: '숫자가 적어도 깊이 연결되는 것을 소중히 여기는 경향이 있습니다. 상대의 본심을 읽는 감수성이 강해 표면적인 관계에는 만족하기 어려운 면도 있습니다. 자신의 내면 세계를 털어놓을 수 있는 상대와의 관계에 특별한 충실감을 느낄 것입니다.',
  },
  INFP: {
    code: 'INFP',
    nameJa: '중재자',
    groupJa: '빛을 엮는 사람들',
    groupCode: 'NF',
    tagline: '시를 쓰는 사람, 섬세한 마음으로 세상의 아름다움을 모으는 사람',
    essence: '내면의 가치관에 충실하며, 아름다움과 의미를 추구하는 사람',
    folderName: '06infp',
    strengths: [
      '아름다움과 의미를 느껴내는 섬세하고 풍부한 감수성',
      '자신의 가치관에 성실하게 살고, 그것을 조용히 표현하는 진지함',
      '타인의 고통과 감정에 깊이 공감하고, 본질적인 위로를 전하는 힘',
    ],
    relationshipNote: '진지하게 마주함으로써 깊은 유대를 키우는 경향이 있습니다. 표면적으로는 수줍어 보일 수 있지만, 가치관을 공유할 수 있는 상대에게는 풍부한 내면 세계를 열어가는 면이 있습니다. 있는 그대로의 자신을 받아들여주는 관계에 가장 큰 평안을 느낄 것입니다.',
  },
  ENFJ: {
    code: 'ENFJ',
    nameJa: '선도자',
    groupJa: '빛을 엮는 사람들',
    groupCode: 'NF',
    tagline: '사람을 따뜻하게 감싸는 빛, 자리를 비추는 존재',
    essence: '공감과 열정으로 사람을 이끌고, 가능성을 끌어내는 사람',
    folderName: '07enfj',
    strengths: [
      '사람의 가능성을 직관적으로 느끼고, 성장을 이끌어내는 공감력',
      '주변 분위기를 읽으며, 자연스럽게 사람을 이끄는 소통 능력',
      '큰 비전을 가지고, 팀을 열정으로 움직이는 리더십',
    ],
    relationshipNote: '상대에 대한 관심과 배려가 자연스럽게 흘러나오는 경향이 있습니다. 주변의 감정에 민감하기 때문에, 때로는 타인의 문제를 너무 많이 떠안을 수도 있습니다. 자신 자신의 케어도 동등하게 소중히 여김으로써, 더 풍요로운 관계를 오래 키워갈 수 있습니다.',
  },
  ENFP: {
    code: 'ENFP',
    nameJa: '활동가',
    groupJa: '빛을 엮는 사람들',
    groupCode: 'NF',
    tagline: '바람과 춤추는 사람, 생명력의 축제',
    essence: '호기심과 열정으로, 사람과 사람, 아이디어를 잇는 사람',
    folderName: '08enfp',
    strengths: [
      '사람과 아이디어의 가능성을 발견하고, 열정으로 전하는 표현력',
      '어떤 상황에서도 새로운 면을 발견하고, 자리에 활력을 주는 감수성',
      '다양한 사람과의 관계를 소중히 하고, 각각의 개성을 이끌어내는 사교성',
    ],
    relationshipNote: '사람과의 만남에 깊은 기쁨을 느끼는 경향이 있습니다. 풍부한 감정과 사람을 끌어당기는 매력이 있는 반면, 때로는 마음이 분산되기 쉬워지는 면도 있습니다. \'이 사람과만\'이라고 생각할 수 있는 깊은 유대에 특별한 충실감을 느끼는 면이 있을 것입니다.',
  },
  ISTJ: {
    code: 'ISTJ',
    nameJa: '현실주의자',
    groupJa: '빛의 수호자들',
    groupCode: 'SJ',
    tagline: '질서를 지키는 사람, 성실함의 수호자',
    essence: '책임감과 일관성으로, 신뢰의 토대를 쌓는 사람',
    folderName: '09istj',
    strengths: [
      '세부 사항까지 꼼꼼하게 확인하고, 확실하게 일을 완수하는 책임감',
      '오랜 시간에 걸쳐 쌓아온 지식과 경험을, 착실하게 축적하는 지속력',
      '약속을 지키고, 흔들림 없는 신뢰성으로 주변에 안심감을 만들어내는 성실함',
    ],
    relationshipNote: '쉽게 마음을 열지 않더라도, 한번 신뢰 관계가 쌓이면 매우 안정적인 유대를 키우는 경향이 있습니다. 감정을 크게 표현하는 것은 어색할 수 있지만, 행동으로 성실함을 보여주는 사람. 장기적으로 함께할 수 있는 관계에 깊은 충실감을 느낄 것입니다.',
  },
  ISFJ: {
    code: 'ISFJ',
    nameJa: '수호자',
    groupJa: '빛의 수호자들',
    groupCode: 'SJ',
    tagline: '따뜻한 방을 지키는 사람, 조용히 사람을 지지하는 사람',
    essence: '배려와 세심함으로, 소중한 사람을 지키는 사람',
    folderName: '10isfj',
    strengths: [
      '상대의 세세한 니즈와 감정의 변화를 민감하게 감지하는 세심함',
      '안정된 환경을 만들고, 조용히 사람을 지지하는 따뜻함',
      '과거의 경험과 배움을 소중히 하고, 현실적으로 일을 진행하는 착실함',
    ],
    relationshipNote: '눈에 띄지 않는 곳에서 사람을 지지하는 것에 기쁨을 느끼는 경향이 있습니다. 자신보다 상대를 우선하는 경우가 많을 수 있지만, 그 깊은 배려는 분명히 사람의 마음에 전달됩니다. 감사의 말을 솔직하게 받아들임으로써 관계가 더욱 풍요로워지는 면이 있습니다.',
  },
  ESTJ: {
    code: 'ESTJ',
    nameJa: '경영자',
    groupJa: '빛의 수호자들',
    groupCode: 'SJ',
    tagline: '구조를 만드는 사람, 사회의 기반을 쌓아올리는 사람',
    essence: '조직화와 실행력으로, 질서 있는 세상을 만드는 사람',
    folderName: '11estj',
    strengths: [
      '사물을 체계적으로 정리하고, 효율적으로 실행에 옮기는 조직력',
      '책임 있는 자리에서 판단을 내리고, 주변을 이끄는 리더십',
      '일관된 기준과 성실함으로, 신뢰받는 존재가 되는 안정감',
    ],
    relationshipNote: '명확함과 공정함을 소중히 여기는 경향이 있습니다. 감정 표현보다 행동으로 애정을 표현하는 타입일 수 있습니다. 상대의 자립성을 존중하면서도, 어려울 때는 믿을 수 있는 존재로 관계를 지지해 가는 면이 있습니다.',
  },
  ESFJ: {
    code: 'ESFJ',
    nameJa: '집정관',
    groupJa: '빛의 수호자들',
    groupCode: 'SJ',
    tagline: '사람과 사람을 잇는 사람, 따뜻한 환대의 마음',
    essence: '조화와 배려로, 사람들의 인연을 가꾸는 사람',
    folderName: '12esfj',
    strengths: [
      '주변의 분위기와 감정의 흐름을 민감하게 읽고, 자리를 화목하게 만드는 힘',
      '사람의 니즈를 파악하고, 선제적으로 지원하는 따뜻한 호스피탈리티',
      '오래 이어지는 인간관계를 소중히 키우고, 커뮤니티의 유대를 깊게 하는 사교성',
    ],
    relationshipNote: '주변과의 조화를 마음에 두고, 사람을 기쁘게 하는 것에 깊은 충실감을 느끼는 경향이 있습니다. 때로는 자신의 마음을 뒤로 미루는 면도 있지만, 그 따뜻함은 분명히 주변 사람들에게 전달되고 있습니다. 자신의 니즈도 소중히 여김으로써, 더 오래 풍요로운 관계를 키울 수 있습니다.',
  },
  ISTP: {
    code: 'ISTP',
    nameJa: '장인',
    groupJa: '빛의 춤추는 자들',
    groupCode: 'SP',
    tagline: '조용한 장인, 손으로 세상을 이해하는 사람',
    essence: '실천과 분석으로, 사물의 구조를 풀어내는 사람',
    folderName: '13istp',
    strengths: [
      '사물의 구조를 손과 사고로 풀어내는 실천적인 문제 해결력',
      '감정에 흔들리지 않고, 상황을 냉정하게 분석하여 최적해를 찾는 논리성',
      '필요할 때 빠르게 행동하고, 제한된 조건에서도 성과를 내는 적응력',
    ],
    relationshipNote: '말보다 행동으로 신뢰를 표현하는 경향이 있습니다. 깊은 감정 표현은 적어 보일 수 있지만, 소중히 여기는 상대에게는 실제 행동과 관여로 성실함을 보여가는 면이 있습니다. 서로의 독립성을 존중할 수 있는 관계에 특히 안심감을 느낄 것입니다.',
  },
  ISFP: {
    code: 'ISFP',
    nameJa: '모험가',
    groupJa: '빛의 춤추는 자들',
    groupCode: 'SP',
    tagline: '감성으로 세상을 그리는 사람, 내면에 시를 품은 사람',
    essence: '섬세한 감수성으로, 아름다움을 표현하는 사람',
    folderName: '14isfp',
    strengths: [
      '세상의 아름다움과 세부에 깃든 가치를 느껴내는 섬세한 감수성',
      '자신의 속도와 가치관을 지키면서, 조용히 존재하는 성실함',
      '지금 이 순간의 체험을 소중히 하고, 감각을 통해 깊이 관여하는 능력',
    ],
    relationshipNote: '말보다 체험과 공유된 시간으로 유대를 키우는 경향이 있습니다. 표면에서는 읽기 어렵더라도, 내면에는 풍부한 감정의 세계가 있습니다. 있는 그대로의 자신을 인정받을 수 있는 관계에 가장 깊은 평안과 기쁨을 느낄 것입니다.',
  },
  ESTP: {
    code: 'ESTP',
    nameJa: '사업가',
    groupJa: '빛의 춤추는 자들',
    groupCode: 'SP',
    tagline: '기회를 잡는 사람, 결단의 순간을 살아가는 사람',
    essence: '행동력과 적응력으로, 지금 이 순간을 개척하는 사람',
    folderName: '15estp',
    strengths: [
      '상황을 순식간에 읽고, 즉각적으로 최선의 행동을 취하는 실천적인 판단력',
      '리스크를 두려워하지 않고, 기회에 뛰어드는 대담함과 행동력',
      '어떤 자리에서도 자연스럽게 리드하고, 주변에 활력을 주는 에너지',
    ],
    relationshipNote: '직접적이고 에너지 넘치는 관계에서 충실감을 느끼는 경향이 있습니다. 감정의 깊이보다 자극이나 공유된 체험을 중시하는 경우도 있지만, 한번 소중하게 생각한 사람에게는 놀라울 정도로 성실한 면이 있습니다. 관계에 솔직함과 직접성을 가지고 오는 것을 소중히 여깁니다.',
  },
  ESFP: {
    code: 'ESFP',
    nameJa: '연예인',
    groupJa: '빛의 춤추는 자들',
    groupCode: 'SP',
    tagline: '자리를 축제로 만드는 사람, 지금 이 순간을 사는 사람',
    essence: '밝음과 사교성으로, 사람들에게 기쁨을 전하는 사람',
    folderName: '16esfp',
    strengths: [
      '자리의 분위기를 읽고, 자연스럽게 사람을 웃게 만드는 밝음과 친근감',
      '지금 이 순간을 전력으로 즐기고, 주변을 끌어들이는 생명력',
      '사람의 감정에 솔직하게 반응하고, 공감과 따뜻함을 아낌없이 표현하는 힘',
    ],
    relationshipNote: '사람과 함께 있는 것에 순수한 기쁨을 느끼는 경향이 있습니다. 깊이 생각하는 것보다 느끼는 것을 우선하는 장면도 있지만, 소중한 사람에 대한 마음은 행동과 미소로 분명히 전달됩니다. 마음 속으로 즐길 수 있는 시간과 상대와의 관계에 특별한 충실감을 느낄 것입니다.',
  },
};
